
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Icon, LatLngBoundsExpression } from 'leaflet';
import { LMap, LTileLayer, LMarker, LControl, LPolyline, LIcon, LGeoJson, LPopup, LPolygon } from 'vue2-leaflet';
import { DeviceInfo } from '@/types/device-info';
import { HistoryData } from '@/types/history';
import { convertDateToReadable } from '@/utils/datetime';
import MapModal from '@/components/devices/popups/MapModal.vue';
import { fill } from '@/utils/location';

type D = Icon.Default & {
    _getIconUrl?: string;
};

delete (Icon.Default.prototype as D)._getIconUrl;
Icon.Default.mergeOptions({
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
});

@Component({
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LControl,
        LPolyline,
        LIcon,
        LGeoJson,
        LPopup,
        'map-modal': MapModal,
        LPolygon,
    },
})
export default class MapControl extends Vue {
    url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    mapCenter: number[] = [-33.865143, 151.2099];
    polyline: LatLngBoundsExpression = [];
    convertDateToReadable = convertDateToReadable;
    isMapModal = false;
    showModalMap = false;
    fill = fill;
    // protected leafletObject= null

    @Prop({ required: true })
    device!: DeviceInfo;

    @Prop({ required: true })
    historyViewType!: string;

    @Prop({ required: true, default: [] })
    locations!: HistoryData[];

    @Prop({ required: false, default: 8 })
    zoom!: number;

    @Prop({ required: true, default: 10 })
    perPage!: number;

    @Prop({ required: false, default: 'height: 350px; z-index: 0' })
    styles!: string;

    @Watch('locations', { immediate: true, deep: true })
    onLocationsChange(locations: HistoryData[]) {
        this.polyline = [];
        if (locations && locations.length) {
            // const lats = locations.map((l) => l.latitude);
            // const lons = locations.map((l) => l.longitude);

            // map focus
            // const centerLat = (Math.min(...lats) + Math.max(...lats)) / 2;
            // const centerLon = (Math.min(...lons) + Math.max(...lons)) / 2;
            // this.mapCenter = [centerLat, centerLon];
            this.mapCenter = [locations[locations.length - 1].latitude, locations[locations.length - 1].longitude];

            const locationsCorordinates: LatLngBoundsExpression = locations.map((l: HistoryData) => [
                l.latitude,
                l.longitude,
            ]);
            this.polyline = locationsCorordinates;
        }

        if (this.$refs.lmap) {
            const bounds: LatLngBoundsExpression = locations.map((l: HistoryData) => [l.latitude, l.longitude]);
            if (bounds.length > 0) (this.$refs.lmap as LMap).fitBounds(bounds);
        }
    }

    // addLayerToMapWithBindings(layer, linkedResource, resourceType) {
    //     layer.mapboardId = linkedResource.id;
    //     layer.resourceType = resourceType;
    //     layer.addTo(this.featureGroup.mapObject);
    //     this.bindTooltipAndEvents(layer, linkedResource, resourceType);
    // }

    //     async onLeafletReady() {
    //   await this.$nextTick();
    //   this.leafletObject = this.$refs.lmap.leafletObject;

    //   new L.Toolbar2.DrawToolbar({
    //     position: "topleft",
    //   }).addTo(this.leafletObject);
    // },

    @Watch('historyViewType', { immediate: true, deep: true })
    onHistoryViewChange(historyViewType: string) {
        this.url =
            this.historyViewType === 'map'
                ? 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                : 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';
    }

    showMapModal() {
        this.isMapModal = true;
        this.showModalMap = false;
        setTimeout(() => {
            this.showModalMap = true;
        }, 10);
    }

    getTimeStamp(location: HistoryData) {
        if (!location.timeCreated && !location.timestamp) return 'N/A';
        let dateVal = location.timeCreated ? location.timeCreated : new Date((location.timestamp as number) * 1000);
        return convertDateToReadable(dateVal);
    }
}
